import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import DashboardLayout from '../../components/DashboardLayout';
import { Skeleton } from '../../components/Skeleton';
import PulseDot from '../../components/PulseDot';
import { timeAgo } from '../../lib/time';

const TONE = { active: 'ok', silent: 'crit', never: 'idle' };

export default function AdminAgents() {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage;
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');

  useEffect(() => {
    api.adminAllAgents().then((r) => setAgents(r.agents || [])).finally(() => setLoading(false));
    const id = setInterval(() => api.adminAllAgents().then((r) => setAgents(r.agents || [])).catch(() => {}), 20000);
    return () => clearInterval(id);
  }, []);

  const shown = agents.filter((a) => {
    if (!q) return true;
    const s = q.toLowerCase();
    return (a.customer?.email || '').toLowerCase().includes(s)
      || (a.customer?.displayName || '').toLowerCase().includes(s)
      || (a.serverLabel || '').toLowerCase().includes(s)
      || (a.licenseKey || '').toLowerCase().includes(s);
  });

  return (
    <DashboardLayout title={t('adminMon.agents_title')} heading={false}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--sp-5)', flexWrap: 'wrap', gap: 12 }}>
        <h1 className="page-title" style={{ margin: 0 }}>{t('adminMon.agents_title')}</h1>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('adminMon.agents_search')} style={{ maxWidth: 260 }} />
      </div>

      {loading ? (
        <div className="card">{[0, 1, 2, 3].map((i) => <Skeleton key={i} className="sk-text" style={{ margin: '14px 0' }} />)}</div>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <div className="list">
            {shown.map((a) => (
              <div className="list-row" key={a.licenseKey} style={{ padding: 'var(--sp-4)', alignItems: 'center' }}>
                <PulseDot tone={TONE[a.agentStatus] || 'idle'} animated={a.agentStatus === 'active'} />
                <div className="row-main">
                  <div style={{ fontWeight: 500, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                    {a.customer
                      ? <Link to={`/admin/customers/${a.customer.id}`}>{a.customer.displayName || a.customer.email}</Link>
                      : a.licenseKey}
                    {a.serverLabel && <span style={{ fontSize: 12, color: 'var(--text-3)' }}>· {a.serverLabel}</span>}
                    {a.health && (
                      <span className={`badge ${a.health.label}`} style={{ fontSize: 11 }} title={t('health.title')}>
                        {a.health.score}
                      </span>
                    )}
                    {a.schemaStatus === 'pending' && <span className="badge" style={{ fontSize: 11 }}>{t('adminMon.schema_pending')}</span>}
                    {a.subscription && a.subscription.status !== 'active' && (
                      <span className="badge crit" style={{ fontSize: 11 }}>{t(`adminMon.sub_${a.subscription.status}`, a.subscription.status)}</span>
                    )}
                  </div>
                  <div style={{ color: 'var(--text-3)', fontSize: 12.5 }}>
                    {t(`onboarding.status_${a.agentStatus === 'never' ? 'waiting' : a.agentStatus}`,
                      a.agentStatus === 'never' ? {} : { ago: a.lastHeartbeatAt ? timeAgo(a.lastHeartbeatAt, lang) : '—' })}
                  </div>
                </div>
                <code style={{ fontSize: 11, color: 'var(--text-3)' }}>{a.licenseKey}</code>
              </div>
            ))}
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
